import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/der-ultimative-guide-zur-kurzbewerbung-was-wie-und-warum.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')